import { motion } from 'framer-motion';
import { useEffect, useRef, useState } from 'react';

const BlurText = ({
  text,
  tag: Tag = 'p',
  delay = 100,
  className = '',
  animateBy = 'words',
}) => {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setInView(true);
        observer.disconnect();
      }
    });

    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  const elements = animateBy === 'words' ? text.split(' ') : text.split('');

  return (
    <Tag ref={ref} className={`w-full text-center flex flex-wrap justify-center gap-1 ${className}`}>
      {elements.map((word, i) => (
        <span key={i} className="flex items-center">
          <motion.span
            initial={{ opacity: 0, y: 20, filter: 'blur(10px)' }}
            animate={
              inView
                ? { opacity: 1, y: 0, filter: 'blur(0px)' }
                : { opacity: 0, y: 20, filter: 'blur(10px)' }
            }
            transition={{ delay: i * (delay / 1000), duration: 0.6 }}
            className="inline-block"
          >
            {word}
          </motion.span>
          {animateBy === 'words' && <span>&nbsp;</span>}
        </span>
      ))}
    </Tag>
  );
};

export default BlurText;
